export const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

export const objectSelector = (obj, path, defaultParams) => {
  const pathKeys = path.split('.');
  let object = Object.assign({}, obj);

  for (let i = 0; i < pathKeys.length; i++) {
    let key = pathKeys[i];
    if (!object || !Object.prototype.hasOwnProperty.call(object, key)) {
      object = defaultParams;
      break;
    }
    object = object[key];
  }
  return object;
}

export const thumbnail = (url, option) => {
  const getFileRoot =
    url => url.substring(0, url.lastIndexOf('.'));
  const getFileExtension =
    url => url.substring(url.lastIndexOf('.'));
  const getGlobalsValue =
    parameter => parameter && typeof parameter != 'undefined' && parameter != '' && parameter != null ? parameter : false;
  const convertToTitleCase =
    string => string && string.length >= 2 ? string.charAt(0).toUpperCase() + string.substring(1).toLowerCase() : string;
  let thumbnailUrl = '';
  if (url && option) {
    const thumbnailActive = getGlobalsValue(window.GLOBALS?.THUMBNAIL_ACTIVE);
    const thumbnailOption = getGlobalsValue(window.GLOBALS?.THUMBNAIL_OPTIONS[option]);
    if (thumbnailActive && thumbnailOption) {
      const _width = getGlobalsValue(thumbnailOption.width);
      const _height = getGlobalsValue(thumbnailOption.height);
      const _quality = getGlobalsValue(thumbnailOption.quality);
      const _crop = getGlobalsValue(thumbnailOption.crop);
      const _upscale = getGlobalsValue(thumbnailOption.upscale);
      thumbnailUrl =
        getFileRoot(url) +
        (_width || _height ? '_size' : '') +
        (_width ? _width : '') +
        (_height ? 'x' + _height : '') +
        (_quality ? '_quality' + _quality : '') +
        (_crop ? '_crop' + convertToTitleCase(_crop) : '') +
        (_upscale ? '_upscale' + convertToTitleCase(_upscale) : '') +
        getFileExtension(url);
    } else {
      thumbnailUrl = url;
    }
  }
  return thumbnailUrl;
};
